angular.module('iconoglobe').directive('mapgeocoder', ['$location', '$state', '$window', 'localStorageService', '$filter', 'cookieStore', '$translate', function (location, route, window, localStorageService, $filter, cookieStore, $translate) {

    return {
        restrict: "AE",
        // require: 'ngModel',
        scope: { someCtrlFn: '&callbackFn' },
        link: function(scope, element, attrs, model) {

          
            var accessToken = 'pk.eyJ1IjoibG91aXNwIiwiYSI6ImNpeHVvd3ZxYzAwM2szMnQ5N2Q1cjB0Z2oifQ.1aIlYGHSc1LXrvhI2GXA9w';

            $translate('views.placeholderCity')
                .then(function (translatedValue) {
                var placeholder = $filter('translate')('views.placeholderCity');
                scope.geocoderPlace = new MapboxGeocoder({
                    accessToken: accessToken,
                    // types: 'place,locality',
                    types: 'place',
                    placeholder: placeholder,
                    clearOnBlur: true,
                    language: attrs.getsearchcookie,
                });
               // console.log(scope.geocoderPlace, 'scope.geocoderPlace')
                scope.geocoderPlace.addTo(element[0]);
               // console.log(scope.geocoderPlace,'scope.geocoderPlace')
                
                scope.geocoderPlace.on('result', function (e) {
                    angular.element('.location-popup-wrap').toggleClass('active');
                    //console.log(e.result,'result');

                    var location_location = e.result.geometry.coordinates;
                   // console.log("inside google place received response", e.result.place_name);
                    // var searchCityInfo = scope.getAddressComponentByPlace(e.result);
                    if (location.path() == '/') {
                        location.path('/').search({ 'at': location_location[0] + "," + location_location[1] });
                        scope.setChildMapview(e.result.place_name);

                    } else {
                        location.path('/').search({ 'at': location_location[0] + "," + location_location[1] });
                    }
                    localStorageService.set('city_search', true);
                    localStorageService.set('city_info', JSON.stringify(e.result.place_name));
                    // element.val('');
                    scope.$apply();
                // results.innerText = JSON.stringify(e.result, null, 2);
                });
            });
                 
            //console.log(element[0], 'mapbox')
        },
        controller: ["$scope", "$rootScope", function(scope, rootScope) {
            scope.setChildMapview = function(searchCityInfo) {
                    localStorageService.set('city_search', true);
                    localStorageService.set('city_info', JSON.stringify(searchCityInfo));
                    rootScope.$broadcast('setMapview', {
                        location: 'city'
                    });
                }
                // scope.getAddressComponentByPlace = function(place) {
                //     var components;
                //     components = {};
                //     angular.forEach(place.address_components, function(address_component) {
                //         angular.forEach(address_component.types, function(type) {
                //             components[type] = address_component.long_name;
                //         });
                //     });
                //     return components;
                // }
        }]
    };
}]);
